(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-categories"] && !Shopify.designMode) return;
  try {
    
  const initAccordion = (container) => {
    if (!container) return;
    const title = container.querySelector('.main-title');

    if (title) {
      // 複数回イベントが登録されるのを防ぐため、一度クリアする
      const newTitle = title.cloneNode(true);
      title.parentNode.replaceChild(newTitle, title);

      newTitle.addEventListener('click', (event) => {
        // h2内のリンク(aタグ)がクリックされた場合は、アコーディオンを動作させずリンクを優先する
        if (event.target.closest('a')) {
          return;
        }
        container.classList.toggle('is-open');
      });
    }
  };

  // ページ初期読み込み時に、ページ内にある全ての対象セクションを初期化
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.custom-collection-hierarchy[data-section-id]').forEach(initAccordion);
  });

  // Shopifyテーマエディタでセクションが追加・再読み込みされた時に初期化
  document.addEventListener('shopify:section:load', (event) => {
    const sectionContainer = document.querySelector(`.custom-collection-hierarchy[data-section-id="${event.detail.sectionId}"]`);
    initAccordion(sectionContainer);
  });

  } catch(e) { console.error(e); }
})();
})();
